import { render } from "./Resigned.vue?vue&type=template&id=1b590036&scoped=true"
import script from "./Resigned.vue?vue&type=script&lang=js"
export * from "./Resigned.vue?vue&type=script&lang=js"

import "./Resigned.vue?vue&type=style&index=0&id=1b590036&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b590036"]])

export default __exports__